import { render, staticRenderFns } from "./ImpresoraCategorias.vue?vue&type=template&id=28057b23&scoped=true"
import script from "./ImpresoraCategorias.vue?vue&type=script&lang=js"
export * from "./ImpresoraCategorias.vue?vue&type=script&lang=js"
import style0 from "./ImpresoraCategorias.vue?vue&type=style&index=0&id=28057b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28057b23",
  null
  
)

export default component.exports